<template>
  <div>

    <!-- Footer -->
    <!-- <footer>
      <div class="container">
        <div class="footer-content mb-2">
          <div class="footer-logo">
            <div class="bg-title mb-2">SWAC</div>
            <div class="text text-uppercase">SouthWestern Accreditation Council </div>
          </div>
          <div class="footer-links">
            
            <router-link class="footer-link"
              v-if="(header[0]) ? header[0].status : false"
              to="/accreditations">Accreditation</router-link>

            <router-link class="footer-link"
              v-if="(header[8]) ? header[8].status : false"
              to="/our-certificates">Certification</router-link>

            <router-link class="footer-link"
              v-if="(header[3]) ? header[3].status : false"
              to="/about">About</router-link>

            <router-link class="footer-link"
              v-if="(header[1]) ? header[1].status : false"
              to="/programs">Programs</router-link>

            <router-link class="footer-link"
              v-if="(header[2]) ? header[2].status : false"
              to="/memberships">Membership</router-link>

            <router-link class="footer-link"
              v-if="(header[4]) ? header[4].status : false"
              to="/contact">Contact us</router-link>

            <router-link class="footer-link"
              v-if="(header[7]) ? header[7].status : false"
              to="/online-trainings">Online Training</router-link>

            <router-link class="footer-link"
              v-if="(header[6]) ? header[6].status : false"
              to="/events">Events & Conferences</router-link>

            <router-link v-for="(pg, idx) in pages" :key="idx"
                :to="{ name: 'show-page', params:{slug: pg.slug}}" 
                class="footer-link"
                :class="(pg.has_footer) ? '' : 'hidden' ">
                {{ pg.title }}</router-link>

          </div>
        </div>
        <div class="footer-bottom d-flex justify-content-between">
          <div class="fb-text">2021 All Rights Reserved © SWAC SouthWestern Accreditation Council 
            <router-link class="ml-2"
                v-if="(header[5]) ? header[5].status : false"
                to="/privacy">Privacy Policy
            </router-link>
          </div>
          <div class="socialmedia d-flex align-items-center">
            <div class="follow-text mr-3">Follow us</div>
            <div class="footer-socialmedia">

              <a v-for="(social, index) in rows" 
                class="facebook-icon social-icon" 
                :href="social.provider_url"
                target="_blank"
                :key="index">
                <i v-if="social.provider.toLowerCase() == 'facebook'"
                  class="fab fa-facebook-f"></i>
                <i v-if="social.provider.toLowerCase() == 'youtube'"
                  class="fab fa-youtube"></i>
                <i v-if="social.provider.toLowerCase() == 'linkedin'"
                  class="fab fa-linkedin-in"></i>
                <i v-if="social.provider.toLowerCase() == 'twitter'"
                  class="fab fa-twitter"></i>
              </a>
              
            </div>
          </div>
        </div>
      </div>
    </footer> -->
    <!-- Footer -->

    <footer>
      <div class="container-fluid">
        <div class="footer-content">
            <div class="bg-title">U.SIA</div>
            <div class="footer-body">
              <div class="footer-links">
                <router-link class="footer-link"
                  v-if="(header[0]) ? header[0].status : false"
                  to="/accreditations">Accreditation</router-link>

                <router-link class="footer-link"
                  v-if="(header[8]) ? header[8].status : false"
                  to="/our-certificates">Certification</router-link>

                <router-link class="footer-link"
                  v-if="(header[3]) ? header[3].status : false"
                  to="/about">About</router-link>

                <router-link class="footer-link"
                  v-if="(header[1]) ? header[1].status : false"
                  to="/programs">Programs</router-link>

                <router-link class="footer-link"
                  v-if="(header[2]) ? header[2].status : false"
                  to="/memberships">Membership</router-link>

                <router-link class="footer-link"
                  v-if="(header[4]) ? header[4].status : false"
                  to="/contact">Contact us</router-link>

                <router-link class="footer-link"
                  v-if="(header[7]) ? header[7].status : false"
                  to="/online-trainings">Online Training</router-link>

                <router-link class="footer-link"
                  v-if="(header[6]) ? header[6].status : false"
                  to="/events">Events &amp; Conferences</router-link>

                <router-link v-for="(pg, idx) in pages" :key="idx"
                    :to="{ name: 'show-page', params:{slug: pg.slug}}" 
                    class="footer-link"
                    :class="(pg.has_footer) ? '' : 'hidden' ">
                    {{ pg.title }}</router-link>
              </div>
              <div class="us-footer-contact">
                <div class="title mb-4">News</div>
                <div class="contact-input d-flex">
                  <input v-model="email" type="search" placeholder="Your mail here" />
                  <button @click="newsletter" class="subscribe-btn">
                    <div class="d-flex align-items-center">Subscribe <span class="icon-back"></span></div>
                  </button>
                </div>
                <div v-if="success" style="color: #080" class="alert-msg mt-2">email sent successfully.</div>
                <div v-if="error" style="color: #f00" class="alert-msg mt-2">this email not valid.</div>
              </div>
            </div>
            <div class="footer-bottom">
              <div class="fb-content d-flex flex-wrap align-items-center">
                <div class="text">2021 All Rights Reserved © USIA <router-link class="ml-2 privacy-link"
                v-if="(header[5]) ? header[5].status : false"
                to="/privacy">Privacy Policy
            </router-link></div>
                <div class="socialmedia d-flex align-items-center">
                  <div class="follow-text mr-3">Follow us</div>
                  <div class="footer-socialmedia">

                    <a v-for="(social, index) in rows" 
                      class="facebook-icon social-icon" 
                      :href="social.provider_url"
                      target="_blank"
                      :key="index">
                      <i v-if="social.provider.toLowerCase() == 'facebook'"
                        class="fab fa-facebook-f"></i>
                      <i v-if="social.provider.toLowerCase() == 'youtube'"
                        class="fab fa-youtube"></i>
                      <i v-if="social.provider.toLowerCase() == 'linkedin'"
                        class="fab fa-linkedin-in"></i>
                      <i v-if="social.provider.toLowerCase() == 'twitter'"
                        class="fab fa-twitter"></i>
                    </a>
                    
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </footer>


  </div>
</template>

<style scoped>
footer {
  background: #001157;
  padding-top: 40px;
}
.bg-title {
  color: #fff;
  border-bottom: 6px solid #CC2F26;
  font-size: 50px;
  padding-bottom: 10px;
}
.footer-body {
  padding: 30px 0 20px;
  display: flex;
  justify-content: space-between;
}
.footer-links {
  display: flex;
  flex-wrap: wrap;
}
.footer-link {
  color: #fff;
  width: 30%;
  margin-bottom: 16px;
  font-size: 19px;
}
.footer-link:hover {
  color: #CC2F26;
}
.title {
  color: #fff;
  line-height: 1;
}
.subscribe-btn:hover {
  background: #010c5b;
}
.subscribe-btn:active {
  opacity: 0.6;
}
.subscribe-btn {
  background: #000F80;
  border: 1px solid #fff;
  columns: #fff;
  padding: 5px 18px
}
.subscribe-btn > div {
  color: #fff;
}
.subscribe-btn .icon-back:before {
  color: #fff;
  font-weight: bold;
}
.contact-input input {
  background: #fff !important;
  padding: 5px 15px;
  min-width: 240px;
  width: calc(100% - 128px);
  border-radius: 0 !important;
}
.fb-content {
  justify-content: space-between;
  padding: 17px 0;
  border-top: 1px solid #fff;
}
.privacy-link {
  color: #fff;
  text-decoration: underline !important;
}
.privacy-link:hover {
  text-decoration: none !important;
}
.text {
  color: #fff;
}
.socialmedia,
.socialmedia a,
.socialmedia div {
  color: #fff;
}
.socialmedia a {
  margin-left: 15px;
}
.socialmedia a:hover {
  color: #CC2F26;
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) { 

}

@media (max-width: 767.98px) { 
  .footer-body {
    display: block;
  }
  .contact-input input {
    min-width: auto;
  }
  .footer-link {
    width: 50%;
  }
  /* .footer-links {
    margin-bottom: 10px;
  } */
  .us-footer-contact {
    margin-bottom: 10px;
  }
  .contact-input {
    max-width: 400px;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) { 

 }

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) { 
  .footer-link {
    width: 50%;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) { 

 }

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) { 

 }
</style>

<script>
import axios from "axios";
export default {
  name: "Footer",
  components: {},
  data() {
    return {
      rows: [],
      header: [],
      pages: [],
      email: '',
      success: false,
      error: false,
    };
  },
  created() {

      axios
      .get(window.baseURL + "/setting")
      .then((res) => {
        this.rows = res.data.social;
        this.header = res.data.header;
      })
      .catch(() => { });


      axios
      .get(window.baseURL + "/pages")
      .then((res) => {
        var data = res.data.rows;
        this.pages = res.data.rows;
      })
      .catch(() => {});
      
  },
  methods: {
    newsletter() {
      const options = {
        url: window.baseURL + '/newsletters',
        method: "POST",
        data: {
          email: this.email
        },
      };

      axios(options)
        .then((res) => {
          console.log(res);
          this.email = "";
          this.success = true;
          this.error = false;
        })
        .catch((err) => {
          console.log(err.message);
          this.error = true;
          this.success = false;
        });
    }
  }
};
</script>
